module.exports = __webpack_public_path__ + "static/img/4.ad37e42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rarity/4.png
// module id = Ebqc
// module chunks = 0